import { DocumentTextIcon } from '@heroicons/react/24/outline';
import CT from '@marketplace-ai/tags';
import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { RichTextArea } from '~/components';
import { useNegotiationBaseline, useNegotiationInputsDisabled } from '../provider';
import { TermCompareSection } from '../sub-components/TermCompareSection';

const TAGS = CT.employer.negotiation;

export const ContractTerms = () => {
  const { setValue } = useFormContext();
  const inputsDisabled = useNegotiationInputsDisabled();
  const negotiation = useNegotiationBaseline();
  const [bonusesTxt, adminCostsTxt, infrastructureTxt, extraTxt] = useWatch({
    name: ['bonusesTxt', 'adminCostsTxt', 'infrastructureTxt', 'extraTxt'],
  });
  const [termsChanged, setTermsChanged] = useState({
    bonusesTxt: false,
    adminCostsTxt: false,
    infrastructureTxt: false,
    extraTxt: false,
  });

  useEffect(() => {
    setTermsChanged({
      bonusesTxt: bonusesTxt !== negotiation?.bonusesTxt,
      adminCostsTxt: adminCostsTxt !== negotiation?.adminCostsTxt,
      infrastructureTxt: infrastructureTxt !== negotiation?.infrastructureTxt,
      extraTxt: extraTxt !== negotiation?.extraTxt,
    });
  }, [bonusesTxt, adminCostsTxt, infrastructureTxt, extraTxt, negotiation]);

  useEffect(() => {
    setValue('bonusesTxtFormatted', negotiation?.bonusesTxt);
    setValue('adminCostsTxtFormatted', negotiation?.adminCostsTxt);
    setValue('infrastructureTxtFormatted', negotiation?.infrastructureTxt);
    setValue('extraTxtFormatted', negotiation?.extraTxt);
  }, [negotiation]);

  return (
    <div className="mt-4">
      <TermCompareSection
        icon={<DocumentTextIcon className="h-5 w-5" />}
        changedTermsCount={Object.values(termsChanged).filter(Boolean).length}
        title="Contract Terms and Conditions"
        terms={[
          {
            label: 'Bonuses & Incentives',
            value: negotiation?.bonusesTxt,
            newValueField: (
              <RichTextArea
                name="bonusesTxt"
                flagged={termsChanged.bonusesTxt}
                disabled={inputsDisabled}
                cyTag={TAGS.contractTermsForm.bonusInput}
              />
            ),
            prevValueName: 'bonusesTxtFormatted',
            prevValueIsHtml: true,
          },
          {
            label: 'Administrative Costs',
            value: negotiation?.adminCostsTxt,
            newValueField: (
              <RichTextArea
                name="adminCostsTxt"
                flagged={termsChanged.adminCostsTxt}
                disabled={inputsDisabled}
                cyTag={TAGS.contractTermsForm.adminCostInput}
              />
            ),
            prevValueName: 'adminCostsTxtFormatted',
            prevValueIsHtml: true,
          },
          {
            label: 'Infrastructure Requirements',
            value: negotiation?.infrastructureTxt,
            newValueField: (
              <RichTextArea
                name="infrastructureTxt"
                flagged={termsChanged.infrastructureTxt}
                disabled={inputsDisabled}
                cyTag={TAGS.contractTermsForm.infrastructureReqsInput}
              />
            ),
            prevValueName: 'infrastructureTxtFormatted',
            prevValueIsHtml: true,
          },
          {
            label: 'Extra Terms',
            value: negotiation?.extraTxt,
            newValueField: (
              <RichTextArea
                name="extraTxt"
                flagged={termsChanged.extraTxt}
                disabled={inputsDisabled}
                cyTag={TAGS.contractTermsForm.extraTermsInput}
              />
            ),
            prevValueName: 'extraTxtFormatted',
            prevValueIsHtml: true,
          },
        ]}
      />
    </div>
  );
};
